import React from "react";
import { Router } from "@reach/router";
import { t } from "@lingui/macro";
import { withI18n } from "@lingui/react";
import Layout from "~/components/layout";
import SEO from "~/components/seo";
import Default from "~/components/deepSearch/index";

const Search = (props) => {
  const i18n = props.i18n;
  const paths = props.pageContext.paths;
  const pageContext = props.pageContext;

  return (
    <Layout
      paths={paths}
      style={{ background: "rgba(241, 244, 245, 0.3)" }}
      id="jumpAnchor"
    >
      <SEO
        title={i18n._(t`Course categories`)}
        lang={pageContext.locale}
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        location={paths}
      />

      {pageContext.locale === "en" ? (
        <Router basepath="/courses/">
          <Default path="/" {...{ pageContext }} />
          <Default path="/:category/" {...{ pageContext }} />
        </Router>
      ) : (
        <Router basepath="/es/cursos/">
          <Default path="/" {...{ pageContext }} />
          <Default path="/:category" {...{ pageContext }} />
        </Router>
      )}
    </Layout>
  );
};

export default withI18n()(Search);
